<template>
    <div class="w-full h-full">
        <div class="w-full h-[30%] md:bg-[#EEDFC8] bg-transparent relative md:static md:flex">
            <div class="h-full md:w-[70%] w-full flex items-center absolute md:static z-20 md:px-2">
                <div class="md:w-full w-[90%] mx-auto flex  md:space-x-3 space-x-1">
                    <div 
                        class="md:h-36 md:w-36 h-28 w-28 rounded-full flex items-center relative">
                        <div class="w-full h-full flex items-center object-cover object-center rounded-full bg-white">
                            <img v-if="user.avatar" class="w-full h-full object-cover object-center rounded-full "
                                :src="user.avatar" alt="" srcset="">
                            <img v-if="user.avatar == '' || user.avatar == null"
                                class="w-20 h-20 mx-auto "
                                src="/logo/mel_logo_noir.png" alt="" srcset="">
                        </div>
                    </div>
                    <div class="h-auto flex items-center ">
                        <div>
                            <div class="flex space-x-2">
                                <div>
                                    <p class="md:text-3xl text-xl font-segoe font-semibold">{{ user.name }}</p>
                                </div>
                                <div>
                                    <svg @click="copyLink" class="w-[0.9rem] md:w-[1.1rem] mx-auto object-cover object-center rounded-full cursor-pointer" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" stroke=""><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M7.05025 1.53553C8.03344 0.552348 9.36692 0 10.7574 0C13.6528 0 16 2.34721 16 5.24264C16 6.63308 15.4477 7.96656 14.4645 8.94975L12.4142 11L11 9.58579L13.0503 7.53553C13.6584 6.92742 14 6.10264 14 5.24264C14 3.45178 12.5482 2 10.7574 2C9.89736 2 9.07258 2.34163 8.46447 2.94975L6.41421 5L5 3.58579L7.05025 1.53553Z" fill="#000000"></path> <path d="M7.53553 13.0503L9.58579 11L11 12.4142L8.94975 14.4645C7.96656 15.4477 6.63308 16 5.24264 16C2.34721 16 0 13.6528 0 10.7574C0 9.36693 0.552347 8.03344 1.53553 7.05025L3.58579 5L5 6.41421L2.94975 8.46447C2.34163 9.07258 2 9.89736 2 10.7574C2 12.5482 3.45178 14 5.24264 14C6.10264 14 6.92742 13.6584 7.53553 13.0503Z" fill="#000000"></path> <path d="M5.70711 11.7071L11.7071 5.70711L10.2929 4.29289L4.29289 10.2929L5.70711 11.7071Z" fill="#000000"></path> </g></svg>
                                </div>
                            </div>
                            <div class="flex space-x-2">
                                <div>
                                    <p v-if="user.sexe == 'Femme'" class="text-md md:text-lg font-segoe text-gray-500">{{
                                        $t('entrepreneuse') }}</p>
                                    <p v-if="user.sexe == 'Homme'" class="text-md md:text-lg font-segoe text-gray-500">{{
                                        $t('entrepreneur') }}</p>
                                </div>
                            </div>
                            <div class="flex items-center md:hidden space-x-2">
                                <div class=" flex space-x-1">
                                    <div class="h-auto flex items-center">
                                        <p class="text-xs md:text-base ">{{ $t('niveau') }} {{ user.niveau }}
                                            <span class="ml-2">{{ user.point }} pts/100</span>
                                        </p>
                                    </div>
                                    <div>
                                        <CircleProgressBar class="w-9 h-9" :colorUnfilled="'#FF9900'" :strokeWidth="'10px'"
                                            :animationDuration="'3s'" :value="user.point ? user.point:0" :max="100">{{ user.niveau }}
                                        </CircleProgressBar>
                                    </div>
                                </div>
                            </div>
                            <div class="flex items-center space-x-2 md:hidden border-gray-300 ">
                                <div class="flex ">
                                    <img class="md:w-6 md:h-6 h-4 hidden md:block" src="/icons/icons8_slide_up@2x.png"
                                        alt="" srcset="">
                                    <img class="md:w-6 md:h-6 h-4 md:hidden" src="/icons/chevronuporange.png" alt=""
                                        srcset="">
                                    <p class="text-xs md:text-base ml-1">{{ user.nbr_suiveur }} {{ $t('abonnes') }}</p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="h-full md:w-[30%] w-full  relative">
                <div class="w-full h-full absolute">
                    <div class="w-full h-full relative">
                        <div class="w-full h-full flex md:items-center justify-end md:justify-normal absolute z-10">
                            <div class="md:mx-auto flex space-x-2 p-1 md:p-0">
                                <div class=" h-auto flex md:items-center">
                                    <img class="md:h-8 h-6" src="/icons/Group 222@2x.png" alt="" srcset="">
                                </div>
                                <div>
                                    <p class="md:text-2xl text-[0.8rem] text-gray-500"><span
                                            class="font-semibold text-black">{{ user.ville }},</span> {{ user.quartier }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="w-full h-full relative">
                            <div class="w-full h-full absolute">
                                <div class="w-full h-full relative">
                                    <div class="w-full h-full bg-white opacity-20 absolute"></div>
                                    <div class="w-full h-full backdrop-blur-sm"></div>
                                </div>
                            </div>
                            <div class="w-full h-full">
                                <img class="w-full h-full object-cover object-center"
                                    src="/images/1280px-Bessengue_City_Douala_08@2x.png" alt="" srcset="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="h-[10%] w-full bg-[#1D04FF] flex items-center">
            <div class="w-[90%] md:w-[98%] mx-auto flex space-x-2">
                <div>
                    <img class="w-16 md:w-8" src="/icons/attention_480px.png" alt="" srcset="">
                </div>
                <div class="h-auto md:hidden flex items-center">
                    <Vue3Marquee class=" text-[0.8rem] md:text-base text-white" behavior="" scrolldelay="200" direction="">{{ $t('alert') }}</Vue3Marquee>
                </div>
                <div class="h-auto hidden  md:flex items-center">
                    <p class="text-white text-[0.8rem] md:text-base xl:mt-[0.2rem]">{{ $t('alert') }}</p>
                </div>
            </div>
        </div>
        <div class="h-[60%] w-full md:flex pb-3 md:pb-0 overflow-y-auto">
            <div class="md:w-[50%] w-full md:h-full flex items-center">
                <div class="w-[90%] mx-auto space-y-3">
                    <p class="mt-5 md:mt-0">{{ $t('description') }}</p>
                    <p class="text-sm text-gray-500 text-justify">{{ user.description }}</p>
                </div>
            </div>
            <div class="md:w-[50%] w-full md:h-full flex items-center">
                <div
                    class="mx-auto lg:flex lg:flex-wrap lg:justify-between md:w-[85%] w-full px-3 md:px-0 space-y-5 lg:space-y-3">
                    <div class=" lg:w-48 w-full space-y-3 ml-2 mt-4 lg:mt-3">
                        <p class="text-sm">{{ $t('quartier') }}</p>
                        <div class="flex justify-between">
                            <div class="h-auto flex items-center">
                                <p class="text-gray-500">{{ user.quartier }}</p>
                            </div>
                            <div class="h-auto flex items-center">
                                <div class="mx-auto w-6 h-6 rounded-full  flex items-center">
                                    <svg class="w-full h-full mr-2 text-green-500 dark:text-green-400 flex-shrink-0"
                                        aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
                                        viewBox="0 0 20 20">
                                        <path
                                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class=" lg:w-48 w-full space-y-3 ml-2 mt-4 lg:mt-0">
                        <p class="text-sm">{{ $t('paysorigine') }}</p>
                        <div class="flex justify-between">
                            <div class="h-auto flex items-center">
                                <p class="text-gray-500">{{ user.mon_pays }}</p>
                            </div>
                            <div class="h-auto flex items-center">
                                <div class="mx-auto w-6 h-6 rounded-full  flex items-center">
                                    <svg class="w-full h-full mr-2 text-green-500 dark:text-green-400 flex-shrink-0"
                                        aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
                                        viewBox="0 0 20 20">
                                        <path
                                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class=" lg:w-48 w-full space-y-3 ml-2 mt-4 lg:mt-0">
                        <p class="text-sm">{{ $t('ville') }}</p>
                        <div class="flex justify-between">
                            <div class="h-auto flex items-center">
                                <p class="text-gray-500">{{ user.ville }}</p>
                            </div>
                            <div class="h-auto flex items-center">
                                <div class="mx-auto w-6 h-6 rounded-full  flex items-center">
                                    <svg class="w-full h-full mr-2 text-green-500 dark:text-green-400 flex-shrink-0"
                                        aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
                                        viewBox="0 0 20 20">
                                        <path
                                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class=" lg:w-48 w-full space-y-3 ml-2 mt-4 lg:mt-0">
                        <p class="text-sm">{{ $t('sexe') }}</p>
                        <div class="flex justify-between">
                            <div class="h-auto flex items-center">
                                <p class="text-gray-500">{{ user.sexe }}</p>
                            </div>
                            <div class="h-auto flex items-center">
                                <div class="mx-auto w-6 h-6 rounded-full  flex items-center">
                                    <svg class="w-full h-full mr-2 text-green-500 dark:text-green-400 flex-shrink-0"
                                        aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
                                        viewBox="0 0 20 20">
                                        <path
                                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class=" lg:w-48 w-full space-y-3 ml-2 mt-4 lg:mt-0">
                        <p class="text-sm">{{ $t('datedenaissance') }}</p>
                        <div class="flex justify-between">
                            <div class="h-auto flex items-center">
                                <p class="text-gray-500">{{ user.date_naissance }}</p>
                            </div>
                            <div class="h-auto flex items-center">
                                <div class="mx-auto w-6 h-6 rounded-full  flex items-center">
                                    <svg class="w-full h-full mr-2 text-green-500 dark:text-green-400 flex-shrink-0"
                                        aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
                                        viewBox="0 0 20 20">
                                        <path
                                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import { CircleProgressBar } from 'vue3-m-circle-progress-bar';
export default {
    components: { CircleProgressBar },
    data() {
        return {
            user: '',
        }
    },
    mounted() {
        this.user = this.$store.state.viewProfil 
    },
    methods: {
        copyLink(){
            var input = document.createElement('input');
            var url = window.location.href;
            document.body.appendChild(input)
            input.value = url
            input.select()
            document.execCommand('copy')
            document.body.removeChild(input)
            window.emitter.emit("alertSucces", ['copy link', this.$i18n.messages[`${localStorage.getItem('langue')}`].messagliencopy])
        }, 
    },
    computed: {
        requestHttp() {
            return this.$store.state.api
        },
        requestAccueil() {
            return this.$store.state.dataAccueil
        },
        requestFile() {
            return this.$store.state.apifile
        },
    }
}
</script>
  
<style>
</style>